;
var CblBasePromotorMaskCtrl;
(function () {
    "use strict";
    CblBasePromotorMaskCtrl = function ($scope, $http, cblUserInfoSrvc, cblPromotorMaskSrvc) {
        if ($scope === undefined) {
            return;
        }

        this.$scope = $scope;
        this.$http = $http;
        this.userService = cblUserInfoSrvc;
        this.promotorService = cblPromotorMaskSrvc;
        this.promotorServiceUrl = window.location.origin + '/CBL-INTERFACCIAFINANZA-MF/services/api/promotor/info';
        this.commissionServiceUrl = window.location.origin + '/CBL-INTERFACCIAFINANZA-MF/services/api/promotor/provvigioni';
        this.disableForm = false;
        this.patternNdg = /^[0-9]{0,7}$/;
        this.gridHeight;
        this.codicePromotoreLastSearch;

        if (this.promotorService.codicePromotore === undefined) {
            this.promotorService.codicePromotore = '';
        }
        
        var gridColumns = [
            { visible: true, cellTooltip: true, headerTooltip: true, displayName: 'Data Competenza', name: 'dataComm', field: 'dataCommissioning', width: '8%', type: 'date', cellFilter: 'date:"dd-MM-yyyy"', enableFiltering: false, cellTemplate: '<div style="text-align: center">{{row.entity[col.field] | date:"dd-MM-yyyy"}}</div>' },
            //{ visible: false, cellTooltip: true, headerTooltip: true, displayName: 'Cod. Promotore', name: 'codProm', field: 'codicePromotore', width: '0'},
            { visible: true, cellTooltip: true, headerTooltip: true, displayName: 'Promotore', name: 'descrProm', field: 'descrizionePromotore', width: '11%', enableFiltering: false },
            //{ visible: false, cellTooltip: true, headerTooltip: true, displayName: 'Cod. Società', name: 'codCompany', field: 'codiceSocieta', width: '0' },
            { visible: true, cellTooltip: true, headerTooltip: true, displayName: 'Società Prodotto', name: 'descCompany', field: 'descrizioneSocieta', width: '13%' },
            //{ visible: false, cellTooltip: true, headerTooltip: true, displayName: 'Cod. Prodotto', name: 'codProd', field: 'codiceProdotto', width: '0' },
            { visible: true, cellTooltip: true, headerTooltip: true, displayName: 'Descr. Prodotto', name: 'descrProd', field: 'descrizioneProdotto', width: '12%' },
            //{ visible: false, cellTooltip: true, headerTooltip: true, displayName: 'Cod. causale Provv.', name: 'codReason', field: 'codiceCausaleProvvigione', width: '0' },
            { visible: true, cellTooltip: true, headerTooltip: true, displayName: 'Causale Provv.', name: 'descrReason', field: 'descrizioneCausaleProvvigione', width: '10%' },
            { visible: true, cellTooltip: true, headerTooltip: true, displayName: 'NDG', name: 'ndgCli', field: 'ndgCliente', width: '6%', type: 'number' },
            { visible: true, cellTooltip: true, headerTooltip: true, displayName: 'Intestazione', name: 'descrCli', field: 'descrizioneCliente', width: '12%' },
            { visible: false, cellTooltip: true, headerTooltip: true, displayName: 'Cod. Conto', name: 'codConto', field: 'codiceConto', width: '0'},
            { visible: false, cellTooltip: true, headerTooltip: true, displayName: 'Cod. Contratto', name: 'codContr', field: 'codiceContratto', width: '0'},
            { visible: true, cellTooltip: true, headerTooltip: true, displayName: 'Data Operazione', name: 'DataCont', field: 'dataContabile', width: '7%', type: 'date', cellFilter: 'date:"dd-MM-yyyy"', enableFiltering: false, cellTemplate: '<div style="text-align: center">{{row.entity[col.field] | date:"dd-MM-yyyy"}}</div>' },
            { visible: true, cellTooltip: true, headerTooltip: true, displayName: 'Imp. Operazione', name: 'impOp', field: 'importoOperazione', width: '7%', type: 'number', cellFilter: 'currency', enableFiltering: false, cellTemplate: '<div style="text-align: right">{{row.entity[col.field] | number: 2}} &euro;</div>' },
            { visible: false, cellTooltip: true, headerTooltip: true, displayName: 'Commissioni Cliente', name: 'commCli', field: 'commissioniCliente', width: '0', type: 'number', cellFilter: 'currency' },
            { visible: false, cellTooltip: true, headerTooltip: true, displayName: 'Commissioni Attive', name: 'codProm', field: 'commissioniAttive', width: '0', type: 'number', cellFilter: 'currency' },
            { visible: true, cellTooltip: true, headerTooltip: true, displayName: 'Imp. base spese', name: 'impSpese', field: 'importoBaseSpese', width: '7%', type: 'number', cellFilter: 'currency', enableFiltering: false, cellTemplate: '<div style="text-align: right">{{row.entity[col.field] | number: 2}} &euro;</div>' },
            { visible: true, cellTooltip: true, headerTooltip: true, displayName: 'Provvigione maturata', name: 'impProvv', field: 'provvigioneMaturata', width: '7%', type: 'number', cellFilter: 'currency', enableFiltering: false, cellTemplate: '<div style="text-align: right">{{row.entity[col.field] | number: 2}} &euro;</div>' },
        ];

        var self = this;
        self.gridOptions = {
            enableSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            enableFiltering: true,
            data: [],
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            exporterCsvFilename: 'Provvigioni.csv',
            exporterCsvColumnSeparator: ';',
            exporterHeaderFilterUseName: false,
            exporterHeaderFilter: function (displayName) { return displayName; },
            exporterFieldCallback: function (grid, row, col, value) {
                if (col.colDef.type) {
                    let colType = col.colDef.type;
                    if (colType.startsWith('date')) {
                        var dateVal = new Date(value);
                        return dateVal.toLocaleDateString();
                    }
                    else if (colType.startsWith('number') && col.colDef.cellFilter) {
                        if (col.colDef.cellFilter) {
                            if (col.colDef.cellFilter.startsWith('currency')) {
                                return value.toFixed(2).replace('.', ',');
                            }
                        }
                    }
                }
                return value;
            },
            exporterColumnScaleFactor: 10,

            exporterMenuCsv: true,
            exporterMenuExcel: false,
            exporterMenuPdf: false,
            enableGrouping: true,
            enableCellEditing: false,
            enableCellEditOnFocus: false,
            treeRowHeaderAlwaysVisible: false,

            enablePagination: true,
            enablePaginationControls: true,
            paginationPageSizes: [25, 50, 100, 200],
            paginationPageSize: 100,
            paginationCurrentPage: 1,

            enableRowSelection: false,
            multiSelect: false,
            enableRowHeaderSelection: false,

            showGridFooter: false,

            enableHorizontalScrollbar: 0,
            enableVerticalScrollbar: 0,

            columnDefs: gridColumns,

            onRegisterApi: function (gridApi) {
                self.gridApi = gridApi;
                self.grid = gridApi.grid;

                self.gridApi.grouping.on.groupingChanged($scope, function (column) {
                    if (column.grouping.groupPriority === undefined) {
                        column.unsort();
                    }
                });

                self.gridApi.pagination.on.paginationChanged($scope, function () {
                    self.gridHeight = self.getGridHeight(self.gridOptions);
                    self.gridOptions.virtualizationThreshold = self.gridOptions.paginationPageSize;
                });

                self.gridApi.core.on.rowsRendered($scope, function () {
                    self.gridApi.pagination.raise.paginationChanged();
                });
            }
        };
    };

    CblBasePromotorMaskCtrl.prototype = {
        MIN_LENGTH_FIELD: 2,
        MIN_LENGTH_NDG: 1,
        MAX_LENGTH_NDG: 7,

        search: function () {
            this.disableForm = true;
            this.promotorService.performedSearch = false;
            this.codicePromotoreLastSearch = this.promotorService.codicePromotore;

            // Collapse del pannello dei dettagli se aperto
            var elementOne = angular.element(document.querySelector('#collapseOne'));
            if ((elementOne !== null) && (elementOne.context !== null) && (elementOne.context !== undefined)) {
                var collapsed = elementOne.context.classList.contains('in');
                if (collapsed) {
                    angular.element('#headerCollapseOne').trigger('click');
                }
            }

            let serviceParams = this.getParams(this.promotorService);

            let successCallback = function (self, data) {
                self.promotorService.commissions = data;
                self.gridOptions.data = data;

                self.gridHeight = self.getGridHeight(self.gridOptions);
                self.promotorService.performedSearch = true;
                self.disableForm = false;
            };
            let errorCallback = function (self, error) {
                self.disableForm = false;
                alert('Richiesta fallita:\n\n   ' + error.status + ": " + error.statusText);
            };
            
            this.getFromUrl(this.commissionServiceUrl, serviceParams, successCallback, errorCallback);
        },

        isFiliale: function () {
            if (typeof this.userService.getSessionInfo === "function") {
                var sessionInfo = this.userService.getSessionInfo();
                if (typeof sessionInfo.Canale !== "undefined") {
                    var canaleBrio = sessionInfo.Canale;
                    switch (canaleBrio) {
                        case 'BRIO_FILIALE':
                            this.promotorService.isFiliale = true;
                            break;
                        case 'BRIO_PROMOTORE':
                            this.promotorService.isFiliale = false;
                            if (typeof sessionInfo.Promoter !== "undefined") {
                                this.promotorService.codicePromotore = sessionInfo.Promoter.codicePromotore;
                            }
                            else {
                                this.promotorService.codicePromotore = sessionInfo.UserName;
                            }
                            break;
                    }
                }
            }

            return this.promotorService.isFiliale;
        },

        getGridHeight: function (gridOptions) {
            var header = gridOptions.enableFiltering ? 62 : 32;
            var footer = gridOptions.showGridFooter ? 31 : 0;
            var paging = gridOptions.enablePagination ? 33 : 0;
            var rowHeight = gridOptions.rowHeight ? gridOptions.rowHeight : 30;

            var datasourceLength = gridOptions.data ? gridOptions.data.length : 0;
            var lastPageSize = datasourceLength % gridOptions.paginationPageSize;
            var countPages = (datasourceLength - lastPageSize) / gridOptions.paginationPageSize + (lastPageSize === 0 ? 0 : 1);
            var currentPageSize = ((gridOptions.paginationCurrentPage < countPages) || !lastPageSize) ? gridOptions.paginationPageSize : lastPageSize;

            var height = ((currentPageSize * rowHeight) + (header + footer + paging));
            return height;
        },

        getParams: function(self) {
            let serviceParams = {};

            serviceParams.codicePromotore = self.codicePromotore;

            if (self.formField.descrCompany) {
                serviceParams.descrizioneSocieta = self.formField.descrCompany;
            }
            if (self.formField.descrProd) {
                serviceParams.descrizioneProdotto = self.formField.descrProd;
            }
            if (self.formField.reasonProvv) {
                serviceParams.descrizioneCausaleProvvigione = self.formField.reasonProvv;
            }
            if (self.formField.ndgCustomer) {
                serviceParams.ndgCliente = self.formField.ndgCustomer;
            }
            if (self.formField.headerCustomer) {
                serviceParams.descrizioneCliente = self.formField.headerCustomer;
            }
            if (self.formField.dateFrom) {
                serviceParams.dataCommissioningDa = self.formField.dateFrom;
            }
            if (self.formField.dateTo) {
                serviceParams.dataCommissioningA = self.formField.dateTo;
            }

            return serviceParams;
        },

        getFromUrl: function(serviceUrl, serviceParams, successCallback, errorCallback) {
            var self = this;

            this.$http({
                method : "GET",
                url : serviceUrl,
                params: serviceParams
            
            }).then(function(result) {
                successCallback(self, result.data)
            }, function(reason) {
                errorCallback(self, reason)
            })
        },

        formReset: function () {
            this.reset();
        },

        reset: function () {
            this.promotorService.formField = {
                descrCompany: '',
                descrProd: '',
                reasonProvv: '',
                ndgCustomer: '',
                headerCustomer: '',
                dateFrom: '',
                dateTo: ''
            };
            this.promotorService.performedSearch = false;
            this.promotorService.codicePromotore = '';
        },

        isGridShowable: function () {
            return ((this.codicePromotoreLastSearch === this.promotorService.codicePromotore) && (this.promotorService.performedSearch))
        },

        isValidDescrCompany: function () {
            var value = this.promotorService.formField.descrCompany;
            return (value.length >= this.MIN_LENGTH_FIELD);
        },

        isValidDescrProd: function () {
            var value = this.promotorService.formField.descrProd;
            return (value.length >= this.MIN_LENGTH_FIELD);
        },

        isValidReasonProvv: function () {
            var value = this.promotorService.formField.reasonProvv;
            return (value.length >= this.MIN_LENGTH_FIELD);
        },

        isValidNdgCustomer: function () {
            var value = this.promotorService.formField.ndgCustomer;
            var patt = new RegExp(this.patternNdg);
            return (value && patt.test(value) && (value.length >= this.MIN_LENGTH_NDG && value.length <= this.MAX_LENGTH_NDG));
        },

        isValidHeaderCustomer: function () {
            var value = this.promotorService.formField.headerCustomer;
            return (value.length >= this.MIN_LENGTH_FIELD);
        },

        isValidDateFrom: function () {
            var value = this.promotorService.formField.dateFrom;
            return !isNaN(new Date(value.toString()));
        },

        isValidDateTo: function () {
            var value = this.promotorService.formField.dateTo;
            return !isNaN(new Date(value.toString()));
        },

        isEmptyDescrCompany: function () {
            return this.isEmpty(this.promotorService.formField.descrCompany);
        },

        isEmptyDescrProd: function () {
            return this.isEmpty(this.promotorService.formField.descrProd);
        },

        isEmptyReasonProvv: function () {
            return this.isEmpty(this.promotorService.formField.reasonProvv);
        },

        isEmptyNdgCustomer: function () {
            return this.isEmpty(this.promotorService.formField.ndgCustomer);
        },

        isEmptyHeaderCustomer: function () {
            return this.isEmpty(this.promotorService.formField.headerCustomer);
        },

        isEmptyDateFrom: function () {
            return this.isEmpty(this.promotorService.formField.dateFrom);
        },

        isEmptyDateTo: function () {
            return this.isEmpty(this.promotorService.formField.dateTo);
        },

        isEmpty: function (field) {
            return (field === undefined || field == null || field.length <= 0) ? true : false;
        },

        searchEnabled: function () {
            let promoterIsSelected = !this.isEmpty(this.promotorService.codicePromotore);
            if (((promoterIsSelected && this.allFiltersAreEmpty()) || (promoterIsSelected && this.allFiltersAreValid())) && (!this.disableForm)) {
                return true;
            }
            else {
                return false;
            }
        },

        allFiltersAreValid: function() {
            return (
                (this.isEmptyDescrCompany() || this.isValidDescrCompany()) &&
                (this.isEmptyDescrProd() || this.isValidDescrProd()) &&
                (this.isEmptyReasonProvv() || this.isValidReasonProvv()) &&
                (this.isEmptyNdgCustomer() || this.isValidNdgCustomer()) &&
                (this.isEmptyHeaderCustomer() || this.isValidHeaderCustomer()) &&
                (this.isEmptyDateFrom() || this.isValidDateFrom()) &&
                (this.isEmptyDateTo() || this.isValidDateTo())
            );
        },

        allFiltersAreEmpty: function() {
            return (
                this.isEmptyDescrCompany() &&
                this.isEmptyDescrProd() &&
                this.isEmptyReasonProvv() &&
                this.isEmptyNdgCustomer() &&
                this.isEmptyHeaderCustomer() &&
                this.isEmptyDateFrom() &&
                this.isEmptyDateTo()
            );
        }
    }

    CblBasePromotorMaskCtrl.$inject = ['$scope', '$http', 'CblUserInfoSrvc', 'CblPromotorMaskSrvc'];

    angular.module('finanzaApp').controller('PromotorMaskCtrl', ['$scope', '$http', 'CblUserInfoSrvc', 'CblPromotorMaskSrvc', CblBasePromotorMaskCtrl]);
}());
